import PropTypes from 'prop-types';
import {Navigate, Outlet, useLocation} from 'react-router';
import {useAuth} from './hooks/AuthContext';

const RequireAuth = ({redirectPath = '/landing'}) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.checkIsLogin) {
    // Optionally return a loading spinner or null while checking
    return null;
  }

  if (!auth.user) {
    return <Navigate to={redirectPath} state={{from: location}} replace />;
  }

  return <Outlet />;
};

RequireAuth.propTypes = {
  redirectPath: PropTypes.string,
};

export default RequireAuth;
